import { FINISH_CREATE_OK, FINISH_CREATE_ERR } from "./finishCreate.action";

const InitState = {
  error: null,
  content: null,
};

export default function finishCreateReducer(state = InitState, action) {
  switch (action.type) {
    case FINISH_CREATE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case FINISH_CREATE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
